import debug from "debug";
const log = debug("interest-form");

function init(element) {
	log("init", element);

	const options = {
		formElement: element,
		rootPathname: element.dataset.ajaxLoaderRootPathname,
		indicatorSelector: element.dataset.interestFormLoadingIndicatorSelector,
		errorEmptySelector: element.dataset.interestFormErrorEmptySelector,
		errorServerSelector: element.dataset.interestFormErrorServerSelector,
		interestCategorySelector: element.dataset.interestCategorySelector,
		interestCategoryCountSelector: element.dataset.interestCategoryCountSelector,
	};

	const state = {
		href: element.action? element.action : window.location.href,
		submitting: false
	};

	element.addEventListener(
		"submit",
		onSubmit.bind(null, { options, state })
	);

	element.addEventListener(
		"change",
		onValueChanged.bind(null, { options })
	);

}

function onSubmit({ options, state }, e) {

	// displayServerError(options, false);

	const { formElement } = options;
	const formData = new FormData(formElement);

	const isValid = validateForm(formData);
	displayEmptyError(options, !isValid);
	if(!isValid) {
		e.preventDefault();
		return false;
	}

	// displayLoading(options, true);

	// postData(options, state, formData);
}

function validateForm(formData) {
	if(formData == null) {
		// valid because there was no form
		return true;
	}

	// require at least one category
	var categories = formData.getAll("category[]");
	if(categories.length == 0) {
		return false;
	}

	return true;
}

function displayEmptyError(options, shouldDisplay) {
	const { formElement, errorEmptySelector } = options;
	const errorElement = formElement.querySelector(errorEmptySelector);
	if(!errorElement) {
		return;
	}
	errorElement.hidden = !shouldDisplay;
}
function displayServerError(options, shouldDisplay) {
	const { formElement, errorServerSelector } = options;
	const errorElement = formElement.querySelector(errorServerSelector);
	if(!errorElement) {
		return;
	}
	errorElement.hidden = !shouldDisplay;
}

function displayLoading(options, shouldDisplay) {
	const { formElement, indicatorSelector } = options;
	// const { getIndicatorTemplate } = handlers;
	const indicator = document.querySelector(indicatorSelector);
	if(!indicator) {
		return;
	}
	indicator.hidden = !shouldDisplay;
}

function postData(options, state, formData) {
	const { href } = state;
	state.submitting = true;

	fetch(href, {
		method: 'POST',
		body: formData
	}).then((response) => {
		if (response.ok) {
			return response.text();
		}
		return Promise.reject(response);
	})
	.then((html) => {
		state.submitting = false;
		displayLoading(options, false);
	})
	.catch((error) => {
		log("error", error);
		// TODO do something
		state.submitting = false;
		displayLoading(options, false);
		displayServerError(options, true);
	});
}

function onValueChanged({options}, e) {
	const { interestCategorySelector } = options;

	const categoryElement = e.target.closest(interestCategorySelector);

	if(!categoryElement) {
		return false;
	}

	updateCountForCategory(options, categoryElement);
}

function updateCountForCategory(options, categoryElement) {
	const { interestCategoryCountSelector } = options;

	const checkedInputs = categoryElement.querySelectorAll('input:checked');
	const newCount = checkedInputs? checkedInputs.length : 0;

	const categoryCountElement = categoryElement.querySelector(interestCategoryCountSelector);
	if(!categoryCountElement) {
		return;
	}
	categoryCountElement.innerText = newCount;
	categoryCountElement.parentNode.hidden = newCount <= 0;
}

export default init;



// WEBPACK FOOTER //
// ./project/client/src/core/components/interest-form/interest-form.js